<template>
	<transition
			appear
			:appear-active-class="$_inpSld_styleInputSliderAnimation()">
		<v-row no-gutters>
			<v-col>
				<v-row no-gutters>
					<v-col>
						<validation-provider
								:name="'InputSlide-' + contentKey"
								:rules="getValidationRules(contents[contentKey].rules)"
								v-slot="{ errors }">
							<v-slider
									v-model="$store.state.input.data[contentKey].answer"

									hide-details

									:always-dirty="$_inpSld_styleSliderAlwaysDirty"
									:background-color="$_inpSld_styleSliderBackgroundColor"
									:color="$_inpSld_styleSliderColor"
									:dark="$_inpSld_styleSliderDark"
									:inverse-label="$_inpSld_styleSliderIntervalLabel"
									:light="$_inpSld_styleSliderLight"
									:thumb-color="$_inpSld_styleSliderThumbColor"
									:thumb-label="$_inpSld_styleSliderThumbLabel"
									:thumb-size="$_inpSld_styleSliderThiumbSize"
									:ticks="$_inpSld_styleSliderTicks"
									:tick-size="$_inpSld_styleSliderTickSize"
									:track-color="$_inpSld_styleSliderTrackColor"

									:append-icon="$_inpSld_styleParamAppendIcon(contents[contentKey].params)"
									:prepend-icon="$_inpSld_styleParamPrependIcon(contents[contentKey].params)"

									:max="$_inpSld_langParamMax(contents[contentKey].params)"
									:min="$_inpSld_langParamMin(contents[contentKey].params)"
									:step="$_inpSld_langParamStep(contents[contentKey].params)"
									:tick-labels="$_inpSld_langParamTickLabels(contents[contentKey].params)"

									:error-messages="errors" />
						</validation-provider>
					</v-col>
				</v-row>
				<template v-if="!isEmpty(contents[contentKey].params.hint)">
					<v-row>
						<v-col>
							<span	class="hint_"
									v-text="$_inpSld_langParamHint(contents[contentKey].params)" />
						</v-col>
					</v-row>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputSlider',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_inpSld_langParamHint() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.hint;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSld_langParamMax() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.max;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSld_langParamMin() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.min;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSld_langParamStep() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.step;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSld_langParamTickLabels() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.tickLabels;
					if(self_.isFalse(param_)) { return null }

					let result_ = []
					param_.forEach(tickLabel => {
						result_.push(self_.getLangsVal(tickLabel))
					})
					return result_
				}
			},
			// style
			$_inpSld_styleInputSlider() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'inputSlider')
				}
			},
			$_inpSld_styleInputSliderAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpSld_styleInputSlider()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpSld_styleSlider() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'slider')
			},
			$_inpSld_styleSliderAlwaysDirty() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.alwaysDirty)
			},
			$_inpSld_styleSliderBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_inpSld_styleSliderColor() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_inpSld_styleSliderDark() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_inpSld_styleSliderIntervalLabel() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.intervalLabel)
			},
			$_inpSld_styleSliderLight() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_inpSld_styleSliderThumbColor() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.thumbColor)
			},
			$_inpSld_styleSliderThumbLabel() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.thumbLabel)
			},
			$_inpSld_styleSliderThiumbSize() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.thumbSize)
			},
			$_inpSld_styleSliderTicks() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.ticks)
			},
			$_inpSld_styleSliderTickSize() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.tickSize)
			},
			$_inpSld_styleSliderTrackColor() {
				const self_ = this;
				const style_ = self_.$_inpSld_styleSlider;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.trackColor)
			},
			$_inpSld_styleParamAppendIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpSld_styleParamPrependIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			}
		}
	}
</script>

<style scoped>
	.hint_ {
		font-size: small;
	}
</style>
